import _ from 'lodash';

/**
 * Returns `true` if the query contains sensitive information, such as credit card info.
 */
const isQuerySensitive = (rawQuery) => {
  const query = rawQuery.toLowerCase();
  // Check for credit card, phone number, or SSN
  const containsAtLeast8Numbers = /(\d[\s-]?){8,}/;
  if (containsAtLeast8Numbers.test(query)) {
    return true;
  }
  // Check for date of birth
  const containsAtLeast4Numbers = /(\d[\s-/,]?){8,}/;
  if (containsAtLeast4Numbers.test(query)) {
    const keywords = ['birth', 'born', 'dob'];
    if (_.some(keywords, (keyword) => query.includes(keyword))) {
      return true;
    }
  }
  // Check for name
  const nameKeyphrases = ['name is', 'my name'];
  if (_.some(nameKeyphrases, (keyphrase) => query.includes(keyphrase))) {
    return true;
  }
  // Check for email
  const containsEmail = /\w+@\w+\.\w+/;
  if (containsEmail.test(query)) {
    return true;
  }
  return false;
};

export default isQuerySensitive;
